import { GridRequestDto } from "../../authentication/connection/interfaces/apiInterfaces";

export class TravelFilterCache {

  private gridRequest: GridRequestDto;
  private selectedId?: number;
  private finishedTravelFilter?: string;
  private webTravelFilter?: boolean;
  private find?: string;
  private bsFromDate: Date;
  private bsToDate: Date;
  private isProgrammed: boolean;
  private selectedTabIdx: number;

  constructor() {
    this.gridRequest = <GridRequestDto>{};
    this.selectedId = null;
    this.finishedTravelFilter = null;
    this.webTravelFilter = null;
    this.find = null;
    this.bsFromDate = new Date();
    this.bsToDate = new Date();
    this.isProgrammed = null;
  }

  public getGridRequest(): GridRequestDto {
    return this.gridRequest;
  }

  public setGridRequest(gridRequest: GridRequestDto): void {
    this.gridRequest = gridRequest;
  }

  public getSelectedId(): number {
    return this.selectedId;
  }

  public setSelectedId(selectedId: number): void {
    this.selectedId = selectedId;
  }

  public getFinishedTravelFilter(): string {
    return this.finishedTravelFilter;
  }

  public setFinishedTravelFilter(finishedTravelFilter: string): void {
    this.finishedTravelFilter = finishedTravelFilter;
  }

  public setWebTravelFilter(webTravelFilter: boolean): void {
    this.webTravelFilter = webTravelFilter;
  }

  public getWebTravelFilter(): boolean {
    return this.webTravelFilter;
  }

  public setFind(find: string): void {
    this.find = find;
  }

  public getFind(): string {
    return this.find;
  }

  public setBsFromDate(fromDate: Date): void {
    this.bsFromDate = fromDate;
  }

  public getBsFromDate(): Date {
    return this.bsFromDate;
  }

  public setBsToDate(toDate: Date): void {
    this.bsToDate = toDate;
  }

  public getBsToDate(): Date {
    return this.bsToDate;
  }

  public setIsProgrammed(isProgrammed: boolean): void {
    this.isProgrammed = isProgrammed;
  }

  public getIsProgrammed(): boolean {
    return this.isProgrammed;
  }

  public getSelectedTabIdx(): number {
    return this.selectedTabIdx;
  }

  public setSelectedTabIdx(value: number): void {
    this.selectedTabIdx = value;
  }
}
